// Migra al LEGACY los datos personales de las personas creadas o actualizadas
// desde la última sincronización (sin asignar proceso ni reclutador). Es la
// misma corrida que el timer del cyber-service ejecuta cada ~10 minutos; este
// botón solo la adelanta.
//
//   POST {APPLICANT}/application/sync-personal-data?userId=<id>
//   → { message, run }
//   GET  {APPLICANT}/application/sync-personal-data-status?userId=<id>
//   → { runs }   (las últimas corridas, la más reciente primero)
//
// Solo el perfil adm_ti ve el botón; el backend vuelve a validar el perfil.

import { readApiErrorMessage } from "../components/pages/Postulaciones/postulacionesUtils";

export interface IMigracionDatosCorrida {
  id: string;
  origin: "TIMER" | "MANUAL";
  status: "EN_CURSO" | "COMPLETADA" | "PARCIAL" | "ERROR" | "INTERRUMPIDA";
  sinceDate: string;
  total: number;
  migrated: number;
  failed: number;
  message: string | null;
  startedAt: string;
  finishedAt: string | null;
}

export interface IMigrarDatosPostulantesResult {
  message: string;
  run?: IMigracionDatosCorrida;
}

const buildUrl = (resource: string): string => {
  const userId = sessionStorage.getItem("usuarioId") ?? "";
  const baseUrl = process.env.REACT_APP_API_APPLICANT;
  if (!baseUrl) throw new Error("Configuración faltante: REACT_APP_API_APPLICANT.");
  return `${baseUrl}/application/${resource}?userId=${encodeURIComponent(userId)}`;
};

export const migrarDatosPostulantes = async (): Promise<IMigrarDatosPostulantesResult> => {
  const res = await fetch(buildUrl("sync-personal-data"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }

  return (await res.json()) as IMigrarDatosPostulantesResult;
};

export interface IEstadoMigracionDatos {
  runs: IMigracionDatosCorrida[];
  /** Hay una migración en curso (solo puede haber una a la vez). */
  running: boolean;
}

export const getEstadoMigracionDatos = async (): Promise<IEstadoMigracionDatos> => {
  const res = await fetch(buildUrl("sync-personal-data-status"));

  if (!res.ok) {
    throw new Error(await readApiErrorMessage(res));
  }

  const body = (await res.json()) as { runs?: IMigracionDatosCorrida[]; running?: boolean };
  const runs = body.runs ?? [];
  // Backend sin `running` (versión anterior): se infiere de la última corrida.
  return { runs, running: body.running ?? runs[0]?.status === "EN_CURSO" };
};
